__webpack_require__.p = "/sekolah/";